import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from "vue";
  import { HouseDesignInterface } from "@/types/HouseDesignInterface";
  import { formatPrice as formatMeters } from "@/helpers/transformation/price";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'HouseDimensionsAndInclusions',
  props: {
    houseInfo: {},
    isDimensionsOpen: { type: Boolean },
    isInclusionsOpen: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const props = __props;

const __returned__ = { props, onMounted, ref, get HouseDesignInterface() { return HouseDesignInterface }, get formatMeters() { return formatMeters } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})